export default __webpack_public_path__ + "static/media/sahana.73323376.jpg";